/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { FiEyeOff, FiEye } from 'react-icons/fi';
import * as S from '../../styles';

export interface IPasswordInputProps {
    id: string;
    fontScale?: number;

    label?: string;
    value?: string;
    errorText?: string;
    required?: boolean;
    readOnly?: boolean;
    placeholder?: string;
    labelColor?: string;
    hasError?: boolean;
    onCompChange?(id: string, payload: any): void;
}

export const PasswordInput = ({
    id,
    fontScale,

    label,
    errorText,
    value,
    required,
    placeholder,
    onCompChange,
    labelColor,
    readOnly,
    hasError,
}: IPasswordInputProps) => {
    const [textValue, setTextValue] = useState(value ?? '');
    const [passwordType, setPasswordType] = useState('password');
    const [isInvalid, setInvalid] = useState(false);

    useEffect(() => {
        setInvalid(hasError);
    }, [hasError]);
    const onChange = (id: string, e: any) => {
        setTextValue(e?.target?.value);
        onCompChange && onCompChange(id, e?.target?.value);
    };
    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const togglePassword = () => {
        if (passwordType === 'password') {
            setPasswordType('text');
            return;
        }
        setPasswordType('password');
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    document.getElementById(`input-${id}`)?.addEventListener('focusin', (e) => {
        console.log(e, 'moi->');
        document
            .getElementById(`input-group-${id}`)
            ?.classList.add('input-group-ch');
    });
    document
        .getElementById(`input-${id}`)
        ?.addEventListener('focusout', (e) => {
            console.log(e, 'moi->');
            document
                .getElementById(`input-group-${id}`)
                ?.classList.remove('input-group-ch');
        });

    return (
        <>
            <Form.Group id={id} className=" formgroup">
                {_renderLabelIf()}
                <InputGroup id={`input-group-${id}`} className="input-group-bt">
                    <S.FormControl
                        fontScale={fontScale}
                        id={`input-${id}`}
                        className="formcontrol shadow-none"
                        value={textValue}
                        onChange={onChange.bind(null, id)}
                        required={required}
                        type={passwordType}
                        placeholder={placeholder}
                        readOnly={readOnly}
                        isInvalid={isInvalid}
                    />
                    <InputGroup.Text
                        style={{ border: 'none', cursor: 'pointer' }}
                        onClick={togglePassword}
                    >
                        {passwordType === 'password' ? (
                            <FiEyeOff size={15} />
                        ) : (
                            <FiEye size={15} />
                        )}
                    </InputGroup.Text>
                    <InputGroup>{_renderErrorTextIf()}</InputGroup>
                </InputGroup>
            </Form.Group>
        </>
    );
};

PasswordInput.defaultProps = {
    required: false,
    readOnly: false,
    hasError: false,
};
